var tuAuthenticationQuestionFieldMap = {
  id: 'id',
  sequence: 'sequence',
  text: 'text',
  type: 'type',
  answers: 'answers',
  __typename: undefined
};
export var TU_AUTHENTICATION_STATUS_PROFILE_FIELD_MAP = {
  questions: ['questions', tuAuthenticationQuestionFieldMap],
  status: 'status',
  authenticatedAt: 'authenticated_at',
  activatedAt: 'activated_at',
  deactivatedAt: 'deactivated_at',
  reactivatedAt: 'reactivated_at',
  blockedAt: 'blocked_at',
  hasThinFile: 'has_thin_file',
  thinFileReason: 'thin_file_reason',
  isDeceased: 'is_deceased',
  notEnoughData: 'not_enough_data',
  numPullsInPast24Hours: 'num_pulls_in_past_24_hours',
  tuId: 'tu_id',
  previousStatus: 'previous_status',
  message: 'message',
  description: 'description',
  __typename: undefined
};
var identityAddressFieldMap = {
  city: 'city',
  longitude: 'longitude',
  state: 'state',
  isValidated: 'is_validated',
  validatedAt: 'validated_at',
  latitude: 'latitude',
  addressLine1: 'address_line_1',
  addressLine2: 'address_line_2',
  validatedBy: 'validated_by',
  zipCode: 'zip_code',
  __typename: undefined
};
var tuInquiryFieldMap = {
  bureau: 'bureau',
  compositeKey: 'composite_key',
  industry: 'industry',
  inquiredAt: 'inquired_at',
  inquiryType: 'inquiry_type',
  subscriberName: 'subscriber_name',
  __typename: undefined
};
var tuPayHistoryBreakDownFieldMap = {
  status: 'status',
  date: 'date',
  __typename: undefined
};
var tuTradelineFieldMap = {
  accountType: 'account_type',
  accountTypeSymbol: 'account_type_symbol',
  accountSubtype: 'account_subtype',
  accountSubtypeSymbol: 'account_subtype_symbol',
  accountNumberLast4: 'account_number_last_4',
  accountDesignator: 'account_designator',
  accountCondition: 'account_condition',
  openClosed: 'open_closed',
  openClosedSymbol: 'open_closed_symbol',
  highBalance: 'high_balance',
  dateReportedAt: 'date_reported_at',
  dateClosedAt: 'date_closed_at',
  dateOpenedAt: 'date_opened_at',
  dateVerifiedAt: 'date_verified_at',
  dateAccountStatus: 'date_account_status',
  currentBalance: 'current_balance',
  creditorName: 'creditor_name',
  bureau: 'bureau',
  creditLimit: 'credit_limit',
  disputeFlag: 'dispute_flag',
  payStatus: 'pay_status',
  payStatusDescription: 'pay_status_description',
  remark: 'remark',
  paymentFrequency: 'payment_frequency',
  worstPayStatus: 'worst_pay_status',
  worstPayStatusSymbol: 'worst_pay_status_symbol',
  amountPastDue: 'amount_past_due',
  collateral: 'collateral',
  lastPaymentDate: 'last_payment_date',
  late30Count: 'late_30_count',
  late60Count: 'late_60_count',
  late90Count: 'late_90_count',
  monthlyPayment: 'monthly_payment',
  monthsReviewed: 'months_reviewed',
  termMonths: 'term_months',
  worstPayStatusCount: 'worst_pay_status_count',
  payHistoryStatus: 'pay_history_status',
  payHistoryStartDate: 'pay_history_start_date',
  payHistoryBreakDown: ['pay_history_break_down', tuPayHistoryBreakDownFieldMap],
  subscriberCodeHash: 'subscriber_code_hash',
  accountNumberHash: 'account_number_hash',
  creditType: 'credit_type',
  compositeKey: 'composite_key',
  nwCreditLimitNormalized: 'nw_credit_limit_normalized',
  nwUtilizationPct: 'nw_utilization_pct',
  nwDateOpenedAtNormalized: 'nw_date_opened_at_normalized',
  nwMonthsOpened: 'nw_months_opened',
  derogatoryTradelineReason: 'derogatory_tradeline_reason',
  payStatusSymbol: 'pay_status_symbol',
  nwPayStatusBucket: 'nw_pay_status_bucket',
  nwLastMissedPaymentDate: 'nw_last_missed_payment_date',
  isIncludedInUtilization: 'is_included_in_utilization',
  __typename: undefined
};
var tuEmployersFieldMap = {
  name: 'name',
  dateReportedAt: 'date_reported_at',
  dateUpdatedAt: 'date_updated_at',
  __typename: undefined
};
export var TU_CREDIT_REPORT_PROFILE_FIELD_MAP = {
  currentAddress: ['current_address', identityAddressFieldMap],
  tradelines: ['tradelines', tuTradelineFieldMap],
  inquiries: ['inquiries', tuInquiryFieldMap],
  avgAgeOfCredit: 'avg_age_of_credit',
  employers: ['employers', tuEmployersFieldMap],
  creditScorePopulationRank: 'credit_score_population_rank',
  hasReportErrors: 'has_report_errors',
  id: 'id',
  inquiryDate: 'inquiry_date',
  isStale: 'is_stale',
  nextReportPullAt: 'next_report_pull_at',
  numAccounts: 'num_accounts',
  numAccounts28Days: 'num_accounts_28_days',
  numAccountsDelta28Days: 'num_accounts_delta_28_days',
  numClosedAccounts: 'num_closed_accounts',
  numClosedAccounts28Days: 'num_closed_accounts_28_days',
  numClosedAccountsDelta28Days: 'num_closed_accounts_delta_28_days',
  numCreditCardAccounts: 'num_credit_card_accounts',
  numDelinquentAccounts: 'num_delinquent_accounts',
  numDerogatoryAccounts: 'num_derogatory_accounts',
  numDerogatoryAccounts28Days: 'num_derogatory_accounts_28_days',
  numDerogatoryAccountsDelta28Days: 'num_derogatory_accounts_delta_28_days',
  numHelocAccounts: 'num_heloc_accounts',
  numInquiries: 'num_inquiries',
  numInquiries28Days: 'num_inquiries_28_days',
  numInquiriesDelta28Days: 'num_inquiries_delta_28_days',
  numMissedPayments: 'num_missed_payment',
  numMortgageAccounts: 'num_mortgage_accounts',
  numOpenAccounts: 'num_open_accounts',
  numOpenAccountsDelta: 'num_open_accounts_delta',
  numOpenAccounts28Days: 'num_open_accounts_28_days',
  numOpenAccountsDelta28Days: 'num_open_accounts_delta_28_days',
  numOtherLoanAccounts: 'num_other_loan_accounts',
  numPersonalLoanAccounts: 'num_personal_loan_accounts',
  numPublicRecords: 'num_public_records',
  numRecentInquiries: 'num_recent_inquiries',
  numStudentLoanAccounts: 'num_student_loan_accounts',
  numUtilityAccounts: 'num_utility_accounts',
  nwAvgAgeOfCreditOpenBucket: 'nw_avg_age_of_credit_open_bucket',
  nwAvgAgeOfCreditOpenMonths: 'nw_avg_age_of_credit_open_months',
  nwAvgAgeOfCreditOpenMonths28Days: 'nw_avg_age_of_credit_open_months_28_days',
  nwAvgAgeOfCreditOpenMonthsDelta28Days: 'nw_avg_age_of_credit_open_months_delta_28_days',
  nwNumMissedPaymentsRecent: 'nw_num_missed_payments_recent',
  nwNumMissedPaymentsRecentBucket: 'nw_num_missed_payments_recent_bucket',
  nwNumOntimeAccounts: 'nw_num_ontime_accounts',
  nwNumOntimeAccounts28Days: 'nw_num_ontime_accounts_28_days',
  nwNumOntimeAccountsDelta28Days: 'nw_num_ontime_accounts_delta_28_days',
  nwPercentUtilization: 'nw_percent_utilization',
  nwPercentUtilizationBucket: 'nw_percent_utilization_bucket',
  nwPercentUtilization28Days: 'nw_percent_utilization_28_days',
  nwPercentUtilizationDelta28Days: 'nw_percent_utilization_delta_28_days',
  nwSumBalancesOpen: 'nw_sum_balances_open',
  nwSumBalancesOpen28Days: 'nw_sum_balances_open_28_days',
  nwSumBalancesOpenDelta28Days: 'nw_sum_balances_open_delta_28_days',
  nwSumBalancesOpenRevolvingLineOfCredit: 'nw_sum_balances_open_revolving_line_of_credit',
  nwSumCreditLimitOpenRevolvingLineOfCredit: 'nw_sum_credit_limit_open_revolving_line_of_credit',
  nwSumCreditLimitOpenRevolvingLineOfCredit28Days: 'nw_sum_credit_limit_open_revolving_line_of_credit_28_days',
  nwSumCreditLimitOpenRevolvingLineOfCreditDelta28Days: 'nw_sum_credit_limit_open_revolving_line_of_credit_delta_28_days',
  percentOnTimePayments: 'percent_on_time_payments',
  percentOnTimePaymentsDelta: 'percent_on_time_payments_delta',
  percentUtilization: 'percent_utilization',
  percentUtilizationDelta: 'percent_utilization_delta',
  publicRecords: 'public_records',
  reportPulledAt: 'report_pulled_at',
  reportPulledAtIterableDatetime: 'report_pulled_at_iterable_datetime',
  safetyCheckPassed: 'safety_check_passed',
  sumAgeOfCredit: 'sum_age_of_credit',
  sumAgeOfCreditDelta: 'sum_age_of_credit_delta',
  sumAssetBackedDebtBalances: 'sum_asset_backed_debt_balances',
  sumAvailableCredit: 'sum_available_credit',
  sumBalances: 'sum_balances',
  sumCreditCardBalances: 'sum_credit_card_balances',
  sumCreditCardLimits: 'sum_credit_card_limits',
  sumHelocBalances: 'sum_heloc_balances',
  sumMonthlyPayments: 'sum_monthly_payments',
  sumMortgageBalances: 'sum_mortgage_balanes',
  sumOtherLoanBalances: 'sum_other_loan_balances',
  sumPersonalLoanBalances: 'sum_personal_loan_balances',
  sumRevolvingDebtBalances: 'sum_revolving_debt_balances',
  sumStudentLoanBalances: 'sum_student_loan_balances',
  sumUtilityBalances: 'sum_utility_balances',
  vantageScore3: 'vantage_score_3',
  vantageScore3Bucket: 'vantage_score_3_bucket',
  vantageScore3Bin: 'vantage_score_3_bin',
  vantageScore3Bin7Days: 'vantage_score_3_bin_7_days',
  vantageScore3Bin28Days: 'vantage_score_3_bin_28_days',
  vantageScore3Delta: 'vantage_score_3_delta',
  vantageScore3DeltaBucket: 'vantage_score_3_delta_bucket',
  vantageScore3DeltaSinceReg: 'vantage_score_3_delta_since_reg',
  vantageScore3Delta7Days: 'vantage_score_3_delta_7_days',
  vantageScore3Delta28Days: 'vantage_score_3_delta_28_days',
  vantageScore3ChangeDirection: 'vantage_score_3_change_direction',
  vantageScore3ChangeDirection7Days: 'vantage_score_3_change_direction_7_days',
  vantageScore3ChangeDirection28Days: 'vantage_score_3_change_direction_28_days',
  __typename: undefined
};